<script setup lang="ts">
// konfetti Gutscheine supplier ID
import { GtmItemListId } from '~/composables/useKftGtm/types'

const supplierID = 'z38lrx'
const eventsPath = 'v1/store/events'
const supplierEventsParams = `?limit=-1&include=supplier,categories&search=supplier_id:${supplierID};hasEvent:false&orderBy=created_at`
const { data: giftcardEventsData } = await useKftApiFetch(
  `${eventsPath}${supplierEventsParams}`,
  { transform: transformToAlgoliaEvent }
)
const {
  title = '',
  isSlider = false,
  showMoreInTitle = false,
  expandable = false,
  maxRows = undefined,
  maxProducts = undefined,
} = defineProps<{
  title?: string
  /** Horizontal rail at every breakpoint instead of a grid from `md:` up. */
  isSlider?: boolean
  /** Show "show more" beside the title — see `ProductShowcase.showMoreInTitle`. */
  showMoreInTitle?: boolean
  /** "Show more" reveals capped products — see `ProductShowcase.expandable`. */
  expandable?: boolean
  /** Caps the showcase to whole grid rows — see `ProductShowcase.maxRows`. */
  maxRows?: number
  /** Hard cap on rendered products — see `ProductShowcase.maxProducts`. */
  maxProducts?: number
}>()
</script>
<template>
  <div>
    <ProductShowcase
      data-test-id="giftcard-events-section"
      :products="giftcardEventsData"
      image-loading="eager"
      :title-h-class="`text-h4 font-semibold md:text-h2`"
      :is-slider="isSlider"
      :is-mobile-slider="!isSlider"
      button-link="/giftcard/"
      :show-more-in-title="showMoreInTitle"
      :expandable="expandable"
      :max-rows="maxRows"
      :max-products="maxProducts"
      :title="title"
      :gtm-item-list-id="GtmItemListId.GeneralPageGiftcardEvents"
      :is-duration-visible="false"
      class="mt-8 md:mt-16"
    />
  </div>
</template>
